import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from "./Navbar/Navbar";
import Home from "./Home/Home";
import './App.css'
import Uav from "./Uav/Uav";
import Awfive from "./AW5/Awfive";
import Fivethen from "./AW15/fivethen"
import Awsix from "./AW6/Awsix";
import Seventhen from "./AW17/Seventhen";
import Twentyone from "./AW21/Twentyone";
import Twentyfive from "./AW25/Twentyfive";
import Twentynine from "./AW29/Twentynine";
import Cone from "./AWC1/Cone";
import Ctwo from "./AWC2/Ctwo";
import ScrollToTop from "./Hooks/ScrollToTop";
import Contact from "./Contact/Contact";
import Aboute from "./Aboute/Aboute";
import News from "./News/News";
import Project from "./Project/Project";
import {useEffect} from "react";


function App() {


    useEffect(() => {
        console.clear();

        console.log(
            "%c⚠️ DANGER WARNING!",
            "color: red; font-size: 48px; font-weight: bold; text-shadow: 2px 2px black;"
        );

        console.log(
            "%cThis browser feature is intended for developers.\nIf someone told you to copy-paste something here,\nit is likely a scam and may compromise your security.",
            "color: white; background-color: red; font-size: 18px; padding: 12px; border-radius: 6px; font-weight: bold;"
        );

    }, []);


    return (
        <div className='App'>
            {/*<Navbar />*/}
<ScrollToTop />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/uav" element={<Uav />} />
                <Route path="/awfive" element={<Awfive />} />
                <Route path="/awsix" element={<Awsix />} />
                <Route path="/fivethen" element={<Fivethen />} />
                <Route path="/seventheen" element={<Seventhen />} />
                <Route path="/twentyone" element={<Twentyone />} />
                <Route path="/twentyfive" element={<Twentyfive />} />
                <Route path="/twentynine" element={<Twentynine />} />
                <Route path="/Cone" element={<Cone />} />
                <Route path="/Ctwo" element={<Ctwo />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/aboute" element={<Aboute />} />
                <Route path="/news" element={<News />} />
                <Route path="/project" element={<Project />} />





            </Routes>

        </div>
    );
}

export default App;
